import TextField from '@TextField';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useBrowserAutoFiller from '../../Hooks/useBrowserAutoFiller/useBrowserAutoFiller';

/**
 * BrowserAutoFiller
 *
 * @description creates an array of TextField components that are hidden from the user, which are used for browser auto-fill. These components are not rendered in view of the user, and are used to capture the auto-fill data from the browser.
 *
 * @returns TextField components that are hidden from the user
 */
const BrowserAutoFiller = () => {
  const { currentPage } = useSelector((store) => store.navigation);
  const { isVisible } = useSelector((store) => store.browserAutoFill);
  const { inputs, setBrowserAutoFillerVisibility } = useBrowserAutoFiller();

  const autoFillInputs = inputs().map((input) => {
    const { id, autoCompleteType, handleChange } = input;
    return (
      <TextField
        key={id}
        onChange={handleChange}
        autoComplete={autoCompleteType}
        id={id}
        data-testid={id}
        inputProps={{
          tabIndex: '-1',
        }}
      />
    );
  });

  useEffect(() => {
    setBrowserAutoFillerVisibility();
  }, [currentPage]);

  if (!isVisible) return null;

  return (
    <div
      style={{ position: 'fixed', left: '-99999px' }}
      data-testid="browserAutofillComponent"
    >
      {autoFillInputs}
    </div>
  );
};

export default BrowserAutoFiller;
